export default __webpack_public_path__ + "images/Y7.fae67be.png";